//@ts-check
import { getCurrentOrganizationAvailableLocations } from './store';

export function getfetchopts(opts = {}) {
  const lab = process.env.REACT_APP_LAB || 'lab3';
  
  const axiosopts = {
    timeout: 30000,
    retry: 0,
    responseType: "json",
    responseEncoding: "utf8",
    validateStatus: function (status) {
      return status >= 200 && status < 300;
    },
    maxRedirects: 0,
    baseURL: window.location.hostname === 'localhost' ? `https://my.${lab}.dev-amie.spectralink.net` : '',
    method: opts.method,
    url: opts.url,
    ...(opts.data && { data: opts.data }),
  };

  const availableLocations = getCurrentOrganizationAvailableLocations();
  
  axiosopts.headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-transform, no-store',
    ...(opts.headers || {})
  };

  if (opts) {
    Object.assign(axiosopts, opts);
  }

  console.info(`DEBUG REQUEST: ${axiosopts.method} ${axiosopts.url}`, ...(axiosopts.data ? [axiosopts.data] :
    axiosopts.params ? [axiosopts.params] : []));

  return axiosopts;
}

export const getExportFileName = (name) => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");

  const dateStr =
    pad(now.getDate()) +
    pad(now.getMonth() + 1) +
    now.getFullYear() +
    pad(now.getHours()) +
    pad(now.getMinutes()) +
    pad(now.getSeconds());

  return `${name} ${dateStr}`;
};